<ng-template #ErrorModal let-modal>
    <div class="modal-center-header" [ngClass]="{'info': isInfo}">
        <div class="icon-box">
            <i *ngIf="!isInfo" class="fas fa-heart-broken"></i>
            <i *ngIf="isInfo" class="far fa-comment"></i>
        </div>
        <button style="outline: none;" type="button" class="close" aria-label="Close" (click)="modal.close(false)"></button>
    </div>
    <div class="modal-body">
        <h2 class="text-center"> {{ errorTitle }} </h2>
        <h5 class="font-weight-normal"> {{ errorMessage }}</h5>
        <div *ngIf="showFullError" class="error-details">
            <ng-container *ngIf="!isObject(fullErrorMessage)">
                <p>{{ fullErrorMessage }}</p>
            </ng-container>
            <ng-container *ngIf="isObject(fullErrorMessage)">
                <ngx-json-viewer [json]="fullErrorMessage" [expanded]="false"></ngx-json-viewer>
            </ng-container>
        </div>
        <div class="buttons">
            <ng-container *ngIf="buttontype == 'ok'">
                <button class="btn btn-primary" (click)="modal.close(false)">Okay</button>
            </ng-container>
            <ng-container *ngIf="buttontype == 'retrycancel'">
                <button class="btn btn-primary" (click)="modal.close(false)">Okay</button>&nbsp;
                <button class="btn btn-secondary" (click)="modal.close(true)">Retry</button>
            </ng-container>
            <ng-container *ngIf="buttontype == 'yesorno'">
                <button class="btn btn-primary" (click)="modal.close(true)">Yes</button>&nbsp;
                <button class="btn btn-secondary" (click)="modal.close(false)">Cancel</button>
            </ng-container>
            <div *ngIf="!isInfo && fullErrorMessage" (click)="showFullError = !showFullError" class="btn btn-link show-complete-error font-weight-light float-right">[Show Full Error]</div>
        </div>
    </div>
</ng-template>

<div style="position: fixed; top: 1rem; right: 1rem; z-index: 1000;">
    <ng-container *ngFor="let note of activeNotifications; index as i;">
        <ngb-alert type="warning" (close)="noteClose(i)">
            {{ note.message }}
        </ngb-alert>
    </ng-container>
</div>